import { Dispatch, Action } from 'redux'
import { TeamCardMapDispatchReturnType } from './types'

export const TeamCardMapDispatch = (
  _dispatch: Dispatch<Action>
): TeamCardMapDispatchReturnType => {
  return {}
}
